/**
 * NovuNotificationBell
 *
 * Renders the Novu in-app notification center bell icon.
 * Only mounts when REACT_APP_NOVU_APP_ID is set — graceful no-op otherwise.
 *
 * Place this inside the top navigation bar next to the user avatar.
 *
 * Required env vars (Vercel):
 *   REACT_APP_NOVU_APP_ID   — found in Novu dashboard → Settings → API Keys
 */

import React from 'react';
import { useAuth } from '../context/AuthContext';

const NOVU_APP_ID = process.env.REACT_APP_NOVU_APP_ID;

const NovuNotificationBell = () => {
  const { user } = useAuth();

  // Don't render if Novu isn't configured or user isn't logged in
  if (!NOVU_APP_ID || !user?.id) return null;

  // Lazy render — only import the heavy Novu bundle when we actually need it
  const NovuLazy = React.lazy(() =>
    import('@novu/notification-center').then((mod) => ({
      default: function NovuWrapper() {
        const { NovuProvider, PopoverNotificationCenter, NotificationBell } = mod;
        return (
          <NovuProvider
            subscriberId={user.id}
            applicationIdentifier={NOVU_APP_ID}
          >
            <PopoverNotificationCenter colorScheme="light">
              {({ unseenCount }) => <NotificationBell unseenCount={unseenCount} />}
            </PopoverNotificationCenter>
          </NovuProvider>
        );
      },
    }))
  );

  return (
    <React.Suspense fallback={null}>
      <NovuLazy />
    </React.Suspense>
  );
};

export default NovuNotificationBell;
